import { mergeWithCss } from "@sc/XDL/Utilities/mergeWithCss";
// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ClickableButtonProps, ClickablePresentationProps } from "@insite/mobius/Clickable";
import getColor from "@insite/mobius/utilities/getColor";
import { viewSelectStyles } from "@sc/Overrides/Widgets/ProductList/ProductListViewSelect";
import AddToList from "@sc/XDL/Icons/AddToList";
import GridView from "@sc/XDL/Icons/GridView";
import { css } from "styled-components";

const sharedClickableStyles: ClickablePresentationProps = {
    css: css`
        padding: 4px 5px;
        border: 1px solid ${getColor("primary")};
        border-radius: 4px 0 0 4px;
        border-right-width: 0;
        &:hover {
            opacity: 0.33;
        }

        &.selected {
            border-color: ${getColor("common.ui9")};
            background-color: ${getColor("common.ui9")};
        }
    `,
};

viewSelectStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

viewSelectStyles.listViewIcon = {
    src: AddToList,
    size: 16,
};

viewSelectStyles.gridViewIcon = {
    src: GridView,
    size: 16,
};

viewSelectStyles.listViewClickable = {
    ...sharedClickableStyles,
};
viewSelectStyles.gridViewClickable = {
    ...mergeWithCss(sharedClickableStyles, {
        css: css`
            border-radius: 0 4px 4px 0;
            border-right-width: 1px;
            border-left-width: 0;
        `,
    }),
};

viewSelectStyles.title = {
    size: 14,
    color: "common.black",
    css: css`
        letter-spacing: 0;
        line-height: 22px;
    `,
};
